import { createDirectionalZoneDetector } from "./zoneShared";

export const detectHiddenZones = createDirectionalZoneDetector({
  zoneName: "hidden",
  zoneLabel: "Hidden",
  isDemand: true,
});
